import isNil from 'lodash/isNil'
import { PLUGIN_NAME } from './plugin-name'

const { videojs } = global
const Menu = videojs.getComponent('Menu')
const MenuItem = videojs.getComponent('MenuItem')

/**
 * contain common functionality for all Menu columns
 * @class
 * @extends Menu
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoMediaCenterMenuBaseColumn extends Menu {
  #pluginAPI

  /**
   * @param {Player|Object} player
   * @param {Object} [options]
   * @returns {void}
   */
  constructor (player, options) {
    super(player, options)
    this.#pluginAPI = this.player()[PLUGIN_NAME]()
  }

  /**
   * create container element
   * @returns {Object}
   */
  // eslint-disable-next-line class-methods-use-this
  createEl () {
    return videojs.dom.createEl('ul', {
      className: 'vjs-menu-column',
    })
  }

  /**
   * format and translate title
   * @param {string} title
   * @returns {string}
   */
  #formatTitle (title) {
    const staticTextTitle = this.#pluginAPI.getStaticText(title)

    if (!isNil(staticTextTitle)) {
      return staticTextTitle
    }
    const defaultTitle = title.toUpperCase
    return defaultTitle
  }

  /**
   * add title item to menu
   * @param {string}
   * @returns {void}
   */
  addTitle (title) {
    const formattedTitle = this.#formatTitle(title)
    const titleCmt = new MenuItem(this.player(), {
      selectable: false,
      label: formattedTitle,
    })
    titleCmt.removeClass('vjs-menu-item')
    titleCmt.addClass('vjs-sub-menu-title')

    this.addItems([titleCmt])
  }

  /**
   * add menu items to menu
   * @param {MenuItem[]} list of items
   * @returns {void}
   */
  addItems (itemsOptions) {
    itemsOptions.forEach((itemMenu) => {
      itemMenu.enableTouchActivity()
      this.addItem(itemMenu)
    })
  }
}
